/* ==========================================================
   ELI PENSON — CUSTOM THEME JS
   Portfolio Filtering
   ========================================================== */

document.addEventListener('DOMContentLoaded', function () {

  var portfolio = document.querySelector('[data-portfolio]');

  if (!portfolio) return;

  var filters = portfolio.querySelectorAll('[data-portfolio-filter]');
  var items = portfolio.querySelectorAll('[data-portfolio-item]');

  filters.forEach(function (filter) {

    filter.addEventListener('click', function () {

      var selectedCategory = this.getAttribute('data-portfolio-filter');

      /* ACTIVE FILTER */
      filters.forEach(function (button) {
        button.classList.remove('is-active');
      });

      this.classList.add('is-active');


      /* FILTER IMAGES */
      items.forEach(function (item) {

        var itemCategory = item.getAttribute('data-category');

        if (
          selectedCategory === 'all' ||
          itemCategory === selectedCategory
        ) {

          item.classList.remove('is-hidden');

          requestAnimationFrame(function () {
            item.classList.add('is-visible');
          });

        } else {

          item.classList.remove('is-visible');
          item.classList.add('is-hidden');

        }

      });

    });

  });


  /* INITIAL STATE */

  items.forEach(function (item) {
    item.classList.add('is-visible');
  });

});